import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EshopExtractedProductsPage } from '@features/admin/eshop-extraction';
import { useAdminEshopExtractedProductStore } from '@features/admin/eshop-extraction/useAdminEshopExtractedProductStore.ts';

const adminEshopExtractedProductsSearchSchema = z.object({
  extractorId: z.coerce.number().optional(),
  status: z.enum(['NEW', 'CHANGED', 'UNCHANGED', 'GONE']).optional(),
  availability: z.enum(['IN_STOCK', 'LOW_STOCK', 'TEMPORARILY_UNAVAILABLE', 'UNAVAILABLE']).optional(),
  // Router parsuje search jako JSON (boolean), ručně psaná URL může přinést string.
  endOfLife: z.union([z.boolean(), z.enum(['true', 'false']).transform(v => v === 'true')]).optional(),
  search: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(50),
});

export type AdminEshopExtractedProductsSearch = z.infer<typeof adminEshopExtractedProductsSearchSchema>;

export const Route = createFileRoute('/admin/eshop-extraction/products/')({
  validateSearch: search => adminEshopExtractedProductsSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { extractorId, status, availability, endOfLife, search, page, size } = ctx.search;
    useAdminEshopExtractedProductStore.getState().loadEshopExtractedProducts({
      extractorId,
      status,
      availability,
      endOfLife,
      search,
      page: page || 1,
      size: size || 50,
    });
  },
});

function RouteComponent() {
  return <EshopExtractedProductsPage />;
}
